import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import {
    getOffersInfoMappedByLocale,
    OffersInfo,
} from '@sxm-de/dev-kits/web-sdk/domains/offers';
import { EligibilityOffer } from '../types/eligibility-offer';
import { trackOffersPresented } from '../helpers/track-offers-presented';

interface OffersSaveForPresentmentFnPayload {
    subscriptionId: string;
}

export type OffersSaveForPresentmentFn = (
    payload: OffersSaveForPresentmentFnPayload,
) => Promise<{
    offers: { offer: EligibilityOffer }[];
    offersInfo: OffersInfo[];
}>;

export function initOffersSaveForPresentmentFn({
    dependencies,
    countryCodeDefault,
    locale,
}: DomainInitPayload): OffersSaveForPresentmentFn {
    const { appEventSdk, clientSdk } = dependencies;
    return async ({ subscriptionId }: OffersSaveForPresentmentFnPayload) => {
        let offerData;
        try {
            offerData = await clientSdk.commerce.eligibility.getOffersSave(
                subscriptionId,
                { country: countryCodeDefault.toUpperCase() },
            );
            if (offerData.offers?.length > 0) {
                trackOffersPresented(appEventSdk, {
                    offers: offerData.offers,
                });
            }
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
        const offersInfo = await getOffersInfoMappedByLocale(
            {
                offerIds: offerData.offers?.map(
                    ({ offer }: { offer: { id: string } }) => offer.id,
                ),
                countryCode: countryCodeDefault,
                locale,
            },
            dependencies,
        );

        return {
            offers: offerData.offers,
            offersInfo,
        };
    };
}
